
import colors from "assets/theme/base/colors";

// Theme colors
const { success, info, lightblue, warning } = colors;

export const lineChartDataDefault = [
  {
    name: "Organic Search",
    data: [330, 150, 300, 220, 500, 250, 400, 230, 500],
  },
  {
    name: "Referral",
    data: [500, 400, 40, 140, 290, 290, 340, 230, 200],
  },
  {
    name: "Direct",
    data: [45, 23, 550, 33, 290, 150, 230, 340, 100],
  },
];

export const lineChartOptionsDefault = {
  chart: {
    toolbar: {
      show: false,
    },
    type: "line",
  },
  tooltip: {
    theme: "dark",
    x: {
      show: false
    }
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  xaxis: {
    //type: "datetime",
    categories: [
    ],
    labels: {
      style: {
        colors: "#696687",
        fontSize: "12px",
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: "#696687",
        fontSize: "12px",
      },
    },
  },
  legend: {
    show: true,
    labels: {
      colors: "#696687",
    },
  },
  grid: {
    borderColor: "#56577A",
    strokeDashArray: 5,
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  markers: {
    size: 4,
    colors: ["#666666", info.charts[100],success.main, info.charts[400], warning.main, info.charts[600]],
    strokeColors: ["#666666", info.charts[100],success.main, info.charts[400], warning.main, info.charts[600]],
    strokeWidth: 2,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    discrete: [],
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  fill: {
    type: "solid",
    colors: ["#666666", info.charts[100],success.main, info.charts[400], warning.main, info.charts[600]],
    opacity: "0",
  },
  colors: ["#666666", info.charts[100], success.main, info.charts[400], warning.main, info.charts[600]],
};
